import GcHeading from '@garmin/components-global/src/components/GcHeading/index.vue';

export default {
  name: 'PcFeatureCard',
  props: {
    image: {
      type: String,
      default: '',
    },
    imgAlt: {
      type: String,
      default: '',
    },
    imgWidth: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
  computed: {
    imgStyles() {
      return {
        width: this.imgWidth,
      };
    },
  },
  components: {
    GcHeading,
  },
};
